export {default as dispatch} from "./src/dispatch";



//////////////////
// WEBPACK FOOTER
// /Users/danfostersmith/Documents/GitHub/crossing-borders/node_modules/d3-dispatch/index.js
// module id = ../../../../d3-dispatch/index.js
// module chunks = vendor